export function isTechHighlightsEmpty() {
    return true;
}
